"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterState = void 0;
const R = __importStar(require("ramda"));
const react_1 = __importDefault(require("react"));
function useFilterState({ initial = '', } = {}) {
    const [search, setSearch] = react_1.default.useState(initial);
    const [input, setInput] = react_1.default.useState();
    const onInputChange = react_1.default.useCallback((next) => {
        setInput(next);
        setSearch(next);
    }, [setSearch, setInput]);
    const clearSearch = react_1.default.useCallback(() => {
        setSearch('');
    }, [setSearch]);
    const clearInput = react_1.default.useCallback(() => {
        setInput(undefined);
    }, [setInput]);
    const hasInput = react_1.default.useMemo(() => {
        return !R.isNil(input);
    }, [input]);
    return {
        clearInput,
        clearSearch,
        hasInput,
        input: input || '',
        onInputChange,
        search,
        setSearch,
    };
}
exports.useFilterState = useFilterState;
